import 'intl';
import { Children } from 'react';
import { IntlProvider } from 'react-intl';
import { connect } from 'react-redux';
import { messages as productionMessages } from './messages';

let currentMessages = null;

const mapStateToProps = ({ intl }) => ({
    ...intl
});

const mapDispathToProps = () => ({});

const IwIntlProvider = (props) => {
    const { ready, children, locale, language } = props;
    const messages = getMessages();

    if (!ready) {
        return null;
    }

    return (
        <IntlProvider locale={locale} messages={messages[language]}>
            {Children.only(children)}
        </IntlProvider>
    );
};

function getMessages() {
    return currentMessages || productionMessages;
}

export function setMessages(newMessages) {
    currentMessages = newMessages;
}

export function restoreMessages() {
    currentMessages = null;
}

// eslint-disable-next-line import/no-default-export
export default connect(mapStateToProps, mapDispathToProps)(IwIntlProvider);
